import { CancelablePromiseType } from '../@sprinx/after-razzle';
import { CataloguePageData } from '../types/CataloguePageData';
import apiClient from './appApi';

export default {
  get: getResource,
};

function getResource(params: { href: string }): CancelablePromiseType<CataloguePageData['catalogueTaxonomy']> {
  return apiClient.get<CataloguePageData['catalogueTaxonomy'], { href: string }>('/v1/catalogue/byPath', params);
}
